
import './App.css';
import TestiMonials from './components/TestiMonials/TestiMonials';
function App() {
  
  return (
    <div>
      <TestiMonials></TestiMonials>
    </div>
  );
}

export default App;
